'use client'

import {ConfigProvider, ThemeConfig} from 'antd'
import ruRU from 'antd/locale/ru_RU'
import React from 'react'

import theme from './theme'

export const antTheme: ThemeConfig = {
  hashed: false,
  token: {
    controlHeight: 45,
    fontSize: 16,
    colorPrimary: theme.colors.primary,
    colorPrimaryActive: theme.colors.dark3,
    fontFamily: 'inherit',
    controlInteractiveSize: 20,
    zIndexPopupBase: 2005
  },
  components: {
    Slider: {
      trackBg: theme.colors.primary,
      dotActiveBorderColor: 'green',
    },
    Button: {
      colorBorder: '#d9d9d963',
      defaultHoverColor: theme.colors.text,
    },
    Tabs: {
      itemActiveColor: theme.colors.gray,
      itemSelectedColor: theme.colors.dark,
      itemHoverColor: theme.colors.dark,
    },
    Collapse: {
      headerBg: theme.colors.white,
      headerPadding: '16px 21px',
    },
    Select: {
      controlHeight: 45,
    },
  },
}

export const withAntTheme = (node: React.ReactNode, theme = antTheme) => (
  <ConfigProvider
    theme={theme}
    locale={{
      ...ruRU,
      Calendar: {
        ...ruRU.Calendar,
        lang: {
          ...ruRU.Calendar?.lang,
          shortMonths: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декаьрт',
          ],
        },
      },
    }}>
    {node}
  </ConfigProvider>
)

export const AntProvider = ({
  children,
  theme = antTheme,
}: React.PropsWithChildren & {theme?: ThemeConfig; original?: boolean}) => withAntTheme(children, theme)
